import { UAParser } from 'ua-parser-js';

const MAC_OS_NAME = 'Mac OS';
const IOS_OS_NAME = 'iOS';
const ua = UAParser();
const isAppleOs = () => {
  return ua.os.name === MAC_OS_NAME || ua.os.name === IOS_OS_NAME;
};

// this will convert {mac: "meta+shift+e", default: "ctrl+shift+e"} to "⌘+Shift+E" or "Ctrl+Shift+E"
const getHotKeyText = hotkey => {
  const hoykeyText = isAppleOs() && hotkey.mac ? hotkey.mac : hotkey.default;
  return hoykeyText.replace('meta', '⌘').split('+').map(e => e.charAt(0).toUpperCase() + e.slice(1)).join('+');
};

export { getHotKeyText, isAppleOs };
//# sourceMappingURL=hotKeyHelper.js.map
